import Vue from 'vue';
import { ProductsState } from './types';

export default {
  activeProduct(state: ProductsState) {
    return (params) => {
      return state.selected[params.jobId][params.elementIndex];
    };
  },
  allSelectedProducts(state: ProductsState) {
    return (jobId) => {
      if (state.selected[jobId] && Array.isArray(state.selected[jobId])) {
        return state.selected[jobId].map((product) => {
          return product;
        });
      }
      return [];
    };
  },
  productDefinition(state: ProductsState) {
    return (productId) => state.definitions[productId];
  },
  productDefinitions(state: ProductsState, getters) {
    return (jobId) => {
      const job = getters.jobEdit(jobId);
      if (!job) {
        return {};
      }
      return state.definitionsByOpportunity[job.opportunity.sfid] || {};
    };
  },
  suppliers(state: ProductsState) {
    return () => state.suppliers || [];
  },
  productOptions(state: ProductsState, getters) {
    return (jobId) => {
      const opportunitySfid = getters.jobEdit(jobId).opportunity.sfid;
      if (!state.definitionsByOpportunity[opportunitySfid]) {
        return [];
      }
      return Object.values(
        state.definitionsByOpportunity[opportunitySfid],
      ).sort(function (a, b) {
        return (<any>a).name.localeCompare(b.name, 'de', {
          sensitivity: 'base',
        });
      });
    };
  },
  selectedProducts(state: ProductsState) {
    return (jobId) => {
      if (!state.selected[jobId]) {
        Vue.set(state.selected, jobId, []);
      }
      return state.selected[jobId];
    };
  },
  serviceLinksForProduct(state: ProductsState, getters) {
    return (jobId, productId) => {
      const opportunitySfid = getters.jobEdit(jobId).opportunity.sfid;
      if (state.definitionsByOpportunity[opportunitySfid]) {
        if (state.definitionsByOpportunity[opportunitySfid][productId]) {
          return state.definitionsByOpportunity[opportunitySfid][productId]
            .services;
        }
      }
    };
  },
};
